/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        loadingIndicator: {
            track: {
                backgroundColor: {
                    value: "#D5E3F1",
                    type: "color",
                },
            },
            indicator: {
                backgroundColor: {
                    value: "#252C44",
                    type: "color",
                },
            },
            linear: {
                borderRadius: {
                    value: "0",
                    type: "dimension",
                },
                sm: {
                    height: {
                        value: "4px",
                        type: "dimension",
                    },
                },
                md: {
                    height: {
                        value: "6px",
                        type: "dimension",
                    },
                },
                lg: {
                    height: {
                        value: "10px",
                        type: "dimension",
                    },
                },
            },
            circular: {
                xs: {
                    height: {
                        value: "16px",
                        type: "dimension",
                    },
                    width: {
                        value: "16px",
                        type: "dimension",
                    },
                    strokeWidth: {
                        value: "2px",
                        type: "dimension",
                    },
                },
                sm: {
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    strokeWidth: {
                        value: "3.5px",
                        type: "dimension",
                    },
                },
                md: {
                    height: {
                        value: "34px",
                        type: "dimension",
                    },
                    width: {
                        value: "34px",
                        type: "dimension",
                    },
                    strokeWidth: {
                        value: "4px",
                        type: "dimension",
                    },
                },
                lg: {
                    height: {
                        value: "42px",
                        type: "dimension",
                    },
                    width: {
                        value: "42px",
                        type: "dimension",
                    },
                    strokeWidth: {
                        value: "6px",
                        type: "dimension",
                    },
                },
                xl: {
                    height: {
                        value: "54px",
                        type: "dimension",
                    },
                    width: {
                        value: "54px",
                        type: "dimension",
                    },
                    strokeWidth: {
                        value: "6px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
